export default __webpack_public_path__ + "static/media/p29.19161be4.jpg";